/* eslint-disable no-unused-vars */
import { createAction, createReducer } from '@reduxjs/toolkit';
import {
  IAction,
  IParceirosRepasse,
  IPeriodoUltimos12Meses,
} from './interfaces/apiInterfaces';
import {
  IFares,
  IInitialState,
  ILastTwelveMonths,
  IParnerPassedOn,
} from './interfaces/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,

  dateSearch: {
    start: '',
    end: '',
  },
  tedsSent: {
    value: 0,
    quantity: 0,
  },
  tedsReceived: {
    value: 0,
    quantity: 0,
  },
  fares: 0 || {
    fiducia: 0,
    global: 0,
    partner: 0,
  },
  faresReceived: {
    value: 0,
    quantity: 0,
  },
  faresPassedOn: {
    value: 0,
    quantity: 0,
  },
  income: {
    value: 0,
  },
  partnerPassedOn: [],
  lastTwelveMonths: [],
};

export const getTedFaresFromApi = createAction(
  '@faresApp/tedFares/GET_TED_FARES_FROM_API'
);

export const gotTedFaresFromApi = createAction<any>(
  '@faresApp/tedFares/GOT_TED_FARES_FROM_API'
);

export const gotErrorFromTedFaresApi = createAction(
  '@faresApp/tedFares/GOT_ERROR_FROM_TED_FARES_API'
);

export const displayTedFares = createAction<boolean>(
  '@faresApp/tedFares/DISPLAY_TED_FARES'
);

export const logoutTedFaresApp = createAction(
  '@faresApp/tedFares/LOGOUT_TED_FARES_APP'
);

function isTypeNumberOrIFares(props: any) {
  const typeOfResponse = typeof props;
  let fares: IFares;
  let value: number;

  switch (typeOfResponse) {
    case 'object':
      fares = {
        fiducia: props.Fiducia,
        global: props.ambiente_382,
        partner: props.Parceiro,
      };
      return fares;

    case 'number':
      value = props;
      return value;

    default:
      return 0;
  }
}

const tedFaresReducer = createReducer(INITIAL_STATE, {
  [getTedFaresFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [gotTedFaresFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    tedsSent: {
      value: action.payload.teds_enviadas.valor,
      quantity: action.payload.teds_enviadas.quantidade,
    },
    tedsReceived: {
      value: action.payload.teds_recebidas.valor,
      quantity: action.payload.teds_recebidas.quantidade,
    },
    fares: isTypeNumberOrIFares(action.payload.tarifas),
    faresReceived: {
      value: action.payload.tarifas_cobradas.valor,
      quantity: action.payload.tarifas_cobradas.quantidade,
    },
    faresPassedOn: {
      value: action.payload.tarifas_repassadas.valor,
      quantity: action.payload.tarifas_repassadas.quantidade,
    },
    partnerPassedOn: action.payload.parceiros_repasse.map(
      (parceiro: IParceirosRepasse) => {
        const data: IParnerPassedOn = {
          partner: parceiro.parceiro,
          amountPassedOn: parceiro.quantidade_repasse,
          valuePassedOn: parceiro.valor_repasse,
          valueReceived: parceiro.valor_recebido,
          income: parceiro.receita,
        };
        return data;
      }
    ),
    lastTwelveMonths: action.payload.periodo_ultimos_12_meses.map(
      (mes: IPeriodoUltimos12Meses) => {
        const data: ILastTwelveMonths = {
          date: mes.data,
          faresReceived: {
            value: mes.tarifas_cobradas.valor,
            quantity: mes.tarifas_cobradas.quantidade,
          },
          faresPassedOn: {
            value: mes.tarifas_repassadas.valor,
            quantity: mes.tarifas_repassadas.quantidade,
          },
        };
        return data;
      }
    ),
    income: {
      value: action.payload.receita.valor,
    },
  }),
  [gotErrorFromTedFaresApi.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
  [displayTedFares.type]: (state: IInitialState, action) => ({
    ...state,
    isActive: action.payload,
  }),
  [logoutTedFaresApp.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,

    dateSearch: {
      start: '',
      end: '',
    },
    tedsSent: {
      value: 0,
      quantity: 0,
    },
    tedsReceived: {
      value: 0,
      quantity: 0,
    },
    faresReceived: {
      value: 0,
      quantity: 0,
    },
    faresPassedOn: {
      value: 0,
      quantity: 0,
    },
    income: {
      value: 0,
    },
    partnerPassedOn: [],
    lastTwelveMonths: [],
  }),
});

export default tedFaresReducer;
